'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TAGS_GTM_CATEGORY = exports.TRIGGER_ADD_TAG_ACTION = exports.REMOVE_TAG_ACTION = exports.ADD_TAG_ACTION = exports.TRIGGER_ADD_TAG_EVENT = exports.REMOVE_TAG_EVENT = exports.ADD_TAG_EVENT = undefined;

var _compose = require('./compose');

var ADD_TAG_EVENT = exports.ADD_TAG_EVENT = 'bc.addTag';
var REMOVE_TAG_EVENT = exports.REMOVE_TAG_EVENT = 'bc.removeTag';
var TRIGGER_ADD_TAG_EVENT = exports.TRIGGER_ADD_TAG_EVENT = 'bc.triggerAddTag';
var ADD_TAG_ACTION = exports.ADD_TAG_ACTION = 'v2-add';
var REMOVE_TAG_ACTION = exports.REMOVE_TAG_ACTION = 'v2-remove';
var TRIGGER_ADD_TAG_ACTION = exports.TRIGGER_ADD_TAG_ACTION = 'v2-trigger-add';
var TAGS_GTM_CATEGORY = exports.TAGS_GTM_CATEGORY = 'v2-tags';

function composeTagEvent(eventName, tagType, action) {
  return (0, _compose.composeEvent)(eventName, {
    gtmValue: 1,
    gtmLabel: tagType,
    gtmCategory: TAGS_GTM_CATEGORY,
    gtmAction: action
  });
}

function composeAddTagEvent(tagType) {
  return (0, _compose.composeAnalytics)([composeTagEvent(ADD_TAG_EVENT, tagType, ADD_TAG_ACTION)]);
}

function composeRemoveTagEvent(tagType) {
  return (0, _compose.composeAnalytics)([composeTagEvent(REMOVE_TAG_EVENT, tagType, REMOVE_TAG_ACTION)]);
}
// TODO: SHEL-286
function composeTriggerAddTagEvent(triggerType) {
  return (0, _compose.composeAnalytics)([composeTagEvent(TRIGGER_ADD_TAG_EVENT, triggerType, TRIGGER_ADD_TAG_ACTION)]);
}

exports.default = {
  composeAddTagEvent: composeAddTagEvent,
  composeRemoveTagEvent: composeRemoveTagEvent,
  composeTriggerAddTagEvent: composeTriggerAddTagEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/tagsEventComposer.js
// module id = 999
// module chunks = 1